//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { ReportType } from './Enums';

export class ReportBundleReportInputItem extends ReportInputItem {
    ReportIDs: string[] = [];
    override readonly Type: ReportType = ReportType.ReportBundle;

    constructor(initializer?: Partial<Omit<ReportBundleReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "ReportBundleReportInputItem";
}
